// Shared catalogs used by the booking flow + admin edit dialog.
// Keep these in sync with the server's /api/packages + validation.

// Top-level add-ons (toggle with optional per_guest pricing)
export const ADD_ONS = [
  { id: 'diy_cake_custom', name: 'DIY Cake (Custom) — from $55', price: 55, type: 'toggle', note: 'Order 1 week ahead; final price varies by design.' },
  { id: 'extra_30_min',    name: 'Extra 30 minutes',            price: 50, type: 'toggle', note: 'Extend party time beyond 120 minutes.' },
];

// Per-child / per-item extras (quantity-based)
export const PREDEFINED_EXTRAS = [
  { id: 'print_cap',         name: 'Print a Cap (cap included)',        price: 19.00, max: 50 },
  { id: 'print_tshirt',      name: 'Print a T-Shirt (shirt included)',  price: 15.00, max: 50 },
  { id: 'print_mug',         name: 'Print a Mug',                       price: 15.00, max: 50 },
  { id: 'byo_print',         name: 'BYO Cap/T-Shirt — Printing only',   price: 5.00,  max: 50 },
  { id: 'extra_pizza_slice', name: 'Extra Pizza Slice',                 price: 2.99,  max: 100 },
  { id: 'goodie_bag_upgrade',name: 'Goodie Bag Upgrade',                price: 6.00,  max: 50 },
  { id: 'gf_df_cupcake',     name: 'Gluten-Free / Dairy-Free Cupcake',  price: 3.00,  max: 50 },
];

// Catalog used by the Custom Extras dropdown (fixed name + price)
export const CUSTOM_EXTRA_CATALOG = [
  { id: 'helium_balloons',  name: 'Helium Balloons',        price: 8.99  },
  { id: 'cup_cakes',        name: 'Cup Cakes (Assorted)',   price: 6.99  },
  { id: 'cheese_cake',      name: 'Cheese Cake (Assorted)', price: 7.99  },
  { id: 'brownies',         name: 'Brownies',               price: 8.99  },
  { id: 'birthday_candles', name: 'Birthday Candles',       price: 3.99  },
  { id: 'bobie_the_bear',   name: 'Bobie the Bear',         price: 18.99 },
  { id: 'plushies',         name: 'Plushies',               price: 19.99 },
  { id: 'chocolate_pops',   name: 'Chocolate Pops',         price: 7.99  },
];

export const TAX_RATE = 0.13;

// Returns ids used across the two add-on catalogs (quick membership checks)
export const ADD_ON_IDS = new Set(ADD_ONS.map((a) => a.id));
export const PREDEFINED_EXTRA_IDS = new Set(PREDEFINED_EXTRAS.map((a) => a.id));
